import React from 'react';
import PropTypes from 'prop-types';


const iconCategories = [
    // Always free
    'solid',
    // Sometimes free
    'regular',
    'brands',
    // Pro only
    'light'
];

/**
 * [Font Awesome](https://fontawesome.com/) icon component.
 */
export default class Icon extends React.Component {
    UNSAFE_componentWillMount() {
        const { fa_script } = this.props;
        const faId = 'font-awesome';
        let faJsElement = document.getElementById(faId);

        if (fa_script && !faJsElement) {
            const element = document.createElement('script');
            element.src = fa_script;
            element.id = faId;
            const body = document.querySelector('body');
            body.appendChild(element);
            return;
        }
    }

    render() {
        const { id, icon_name, icon_category, icon_color, title, style } = this.props;
        let { className } = this.props;
        className = className || '';
        // noinspection CheckTagEmptyBody
        const category =  icon_category
            ? iconCategories[iconCategories.indexOf(icon_category)][0]
            : iconCategories[0][0];
        return <i
            id={id}
            className={`fa${category} fa-${icon_name} ${className}`}
            title={title || ''}
            style={{...style, color: icon_color || 'inherit'}}>
        </i>
    }
};

Icon.defaultProps = {};

Icon.propTypes = {
    /**
     * The ID of this component, used to identify Dash components
     * in callbacks. The ID needs to be unique across all of the
     * components in an app.
     */
    id: PropTypes.string,

    /**
     * A class name to append to the font-awesome classes.
     */
    className: PropTypes.string,

    /**
     * The name of the font-awesome icon without the fa-
     */
    icon_name: PropTypes.string,

    /**
     * The Font Awesome category for the icon. One of
     *      - solid
     *      - regular
     *      - brands
     */
    icon_category: PropTypes.oneOf(iconCategories),

    /**
     * The icon's color.
     */
    icon_color: PropTypes.string,

    /**
     * Additional style object.
     */
    style: PropTypes.object,

    /**
     * A script link to the Font Awesome JavaScript library.
     * By default, the free icons are included automatically.
     * If you have a license for the pro icons, then include
     * your own script with this attribute.
     */
    fa_script: PropTypes.string,

    /**
     * Tooltip hover text for the icon. Maps to the underlying
     * [title](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/title)
     * attribute.
     */
    title: PropTypes.string,

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.any
};
